// extracted by mini-css-extract-plugin
export default {"root":"UkjJo7YtVB8Lw39wAZUw","itemSelector":"GIICCfBRpNINKjqOy5u7"};